var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Items","page-icon":"mdi-format-list-bulleted","collection-name":"item","items-per-page":20,"add-dialog-title":"Add Item","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }